import { Action, isType } from 'ts-action'

import { IBaseReducer } from 'models/BaseReducer'
import { IFavorite } from 'models/Favorite'
import {
  ClearFavorerBusinessesReducer,
  FavorerBusinessesFetching,
  GetFavorerBusinesses,
  GetFavorerBusinessesErrors,
} from 'data/upshifter/FavorerBusinesses/actions'

export interface IFavorerBusinessesesReducer extends IBaseReducer<IFavorite[]> {
  hasMore: boolean
}

const initialState: IFavorerBusinessesesReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const favorerBusinessesReducer = (
  state = initialState,
  action: Action,
) => {
  if (isType(action, GetFavorerBusinesses)) {
    const { data, meta } = action.payload
    return {
      ...state,
      meta: meta,
      data: data,
      error: undefined,
    }
  }
  if (isType(action, GetFavorerBusinessesErrors)) {
    const { payload } = action
    return {
      ...state,
      error: payload,
    }
  }
  if (isType(action, FavorerBusinessesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, ClearFavorerBusinessesReducer)) {
    return initialState
  }
  return state
}
